module.exports = __webpack_public_path__ + "img/pop_share_red.1775439203884.jpeg";